var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.5 55.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 69"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.12,
    cy: 26.91,
    r: 7.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.38,
    cy: 45.97,
    r: 7.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.38,
    cy: 9.12,
    r: 7.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.43 23.42 21.28-10.49m0 29.54L16.43 31.99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9207dee1e2b738ead183c82f16bb6495.svg";
export { ForwardRef as ReactComponent };